<!--<div>{{ options.chartHeader }}</div>-->


<ng-container *ngIf="_results | async as results; else loading;">

  <div style="display:flex; flex-direction: column; height:100%">
    <div class="chart-container" style="flex: 1 1 auto; overflow:hidden">
      <ngx-charts-bar-vertical-stacked style="padding:1px"
                                       [view]="view | async"
                                       [scheme]="options?.colourScheme ?? scheme"
                                       [results]="_resultsPage | async"
                                       [barmaxwidth]="25"
                                       [xAxis]="showXAxis"
                                       [yAxis]="showYAxis"
                                       [legend]="showLegend"
                                       [legendTitle]="legendTitle"
                                       [showXAxisLabel]="showXAxisLabel"
                                       [showYAxisLabel]="showYAxisLabel"
                                       [xAxisLabel]="options?.xAxisLabel"
                                       [yAxisLabel]="options?.yAxisLabel"
                                       [animations]="animations"
                                       (select)="onSelect($event)">

        <ng-template *ngIf="eveTooltipTemplate != null" #tooltipTemplate let-model="model">
          <ng-container *ngTemplateOutlet="eveTooltipTemplate;context:{model}"></ng-container>
        </ng-template>

      </ngx-charts-bar-vertical-stacked>
    </div>

    <mat-paginator [style.display]="results.length > 10 ? 'block': 'none'" [length]="results.length" [pageSize]="10" [pageSizeOptions]="[10,20,30,40,50,60,70,80,90,100]"></mat-paginator>
    <div [innerHTML]="legendStyles | async">
    </div>
  </div>








</ng-container>

<ng-template #loading>
  <span class="fa fa-spinner fa-pulse fa-5x" style="opacity: 1; color:gray;"></span>
</ng-template>






